/**
 * Shared free-text wire policy for Taxes & Fees labels — SCRUM-213.
 *
 * Mirrors the domain text policies (`_tax-text-policy.ts` / `_fee-text-policy.ts`)
 * EXACTLY so the wire schema is the canonical rejection point (CLAUDE.md rule 3):
 * a label is trimmed, non-empty, at most `max` Unicode codepoints, and contains
 * no control characters (C0 U+0000-U+001F, DEL U+007F, C1 U+0080-U+009F).
 * Without the control-character check a label carrying e.g. an embedded
 * U+0000 would pass the global `ZodValidationPipe` and only fail later at VO
 * construction inside the controller.
 */
import { z } from 'zod';
function hasControlChar(s) {
    for (const ch of s) {
        const cp = ch.codePointAt(0) ?? 0;
        if (cp <= 0x1f || cp === 0x7f || (cp >= 0x80 && cp <= 0x9f)) {
            return true;
        }
    }
    return false;
}
/** Trimmed, non-blank, at most `max` codepoints, no control characters. */
export const boundedText = (max) => z
    .string()
    .trim()
    .min(1)
    .refine((s) => [...s].length <= max, { message: `must be at most ${max} characters` })
    .refine((s) => !hasControlChar(s), { message: 'must not contain control characters' });
//# sourceMappingURL=_text.js.map